/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { CommonModule } from '@angular/common';
import {
    NgModule
} from '@angular/core';
import { FcResponsiveAgDialogHolderComponent } from './fc-responsive-ag-dialog-holder.component';
import { FcResponsiveAgDialogWrapperComponent } from './fc-responsive-ag-dialog-wrapper.component';
import { FcResponsiveAgDialogSimpleMessageComponent } from './fc-responsive-ag-dialog-simple-message.component';
import {
    defaultFcResponsiveAgDialogOptions,
    DefaultFcResponsiveAgDialogOptionConfig
} from './fc-responsive-ag-dialog-options';
import {FcResponsiveAgDialogService} from './fc-responsive-ag-dialog.service';

/**
 * Dialog module with Angular.
 */
@NgModule({
    declarations: [
        FcResponsiveAgDialogHolderComponent, 
        FcResponsiveAgDialogWrapperComponent, 
        FcResponsiveAgDialogSimpleMessageComponent
    ],
    providers: [
        FcResponsiveAgDialogService,
        {
            provide: DefaultFcResponsiveAgDialogOptionConfig,
            useValue: defaultFcResponsiveAgDialogOptions
        }
    ],
    imports: [CommonModule],
    entryComponents: [
        FcResponsiveAgDialogHolderComponent, 
        FcResponsiveAgDialogWrapperComponent
    ]
})
export class FcResponsiveAgDialogModule {
    /**
     * Default constructor.
     */
    constructor() {}
}